import React from 'react';

interface IconLocationProps {
  className?: string;
  size?: number;
  color?: string;
}

export const IconLocation: React.FC<IconLocationProps> = ({ className = '', size = 16, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3332 6.66732C13.3332 11.0007 7.99984 14.6673 7.99984 14.6673C7.99984 14.6673 2.6665 11.0007 2.6665 6.66732C2.6665 5.25283 3.22841 3.89628 4.2286 2.89608C5.2288 1.89589 6.58535 1.33398 7.99984 1.33398C9.41433 1.33398 10.7709 1.89589 11.7711 2.89608C12.7713 3.89628 13.3332 5.25283 13.3332 6.66732Z"
        stroke={color}
        strokeWidth="1.33333"
      />
      <path
        d="M10 6.66797C10 7.1984 9.78929 7.70711 9.41421 8.08218C9.03914 8.45726 8.53043 8.66797 8 8.66797C7.46957 8.66797 6.96086 8.45726 6.58579 8.08218C6.21071 7.70711 6 7.1984 6 6.66797C6 6.13754 6.21071 5.62883 6.58579 5.25376C6.96086 4.87868 7.46957 4.66797 8 4.66797C8.53043 4.66797 9.03914 4.87868 9.41421 5.25376C9.78929 5.62883 10 6.13754 10 6.66797Z"
        stroke={color}
        strokeWidth="1.33333"
      />
    </svg>
  );
};

export default IconLocation;
